/** Where a record reference (notification, dashboard item) leads; modules add their record types here. */
export const REFERENCE_ROUTES: Record<string, (id: string) => string> = {
  task: (id) => `/tasks/${id}`,
  strategy_node: (id) => `/strategy/nodes/${id}`,
  stakeholder: (id) => `/stakeholders/${id}`,
  enablement_program: (id) => `/stakeholders/programs/${id}`,
  beneficiary: (id) => `/beneficiaries/${id}`,
  employee: (id) => `/people/${id}`,
  leave_request: (id) => `/leave/requests/${id}`,
  // Attendance notifications carry a day or a deduction; both are read on a page, not on a record of their own.
  attendance_day: () => '/attendance',
  attendance_team: () => '/attendance/team',
  attendance_deduction: () => '/attendance/team',
  // Performance: the person's own page, or the reviews page opened on the cycle or the review.
  performance_mine: () => '/performance',
  performance_cycle: (id) => `/performance/reviews?cycle=${id}`,
  performance_review: (id) => `/performance/reviews?review=${id}`,
  // A contract's reminders (follow-ups and overdue invoices) open the contract itself.
  service_contract: (id) => `/contracts/${id}`,
};

export const referenceRoute = (type: string | null | undefined, id: string | null | undefined): string | undefined => (type && id ? REFERENCE_ROUTES[type]?.(id) : undefined);
